import { render, staticRenderFns } from "./DepositList.vue?vue&type=template&id=3ae0efda&scoped=true"
import script from "./DepositList.vue?vue&type=script&lang=js"
export * from "./DepositList.vue?vue&type=script&lang=js"
import style0 from "./DepositList.vue?vue&type=style&index=0&id=3ae0efda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae0efda",
  null
  
)

export default component.exports